import React from "react";
import {
  AxiosInterceptors,
  createRequestLog,
  createResponseErrorLog,
  createResponseLog,
} from "@hopper-b2b/api";
import { getLang, useI18nContext } from "@hopper-b2b/i18n";
import type { TrackingPropertiesType } from "@hopper-b2b/types";
import { useFeatureFlagsContext, useUtmTracking } from "@hopper-b2b/utilities";
import { v4 as uuidv4 } from "uuid";

const version = import.meta.env.VITE_REACT_APP_VERSION ?? `local-${uuidv4()}`;

interface IAxiosInterceptors {
  children?: React.ReactNode;
  hopperSessionToken?: string;
}

export const AxiosInterceptorWrapper = ({ children }: IAxiosInterceptors) => {
  const featureFlags = useFeatureFlagsContext();
  const { userCampaign, userMedium, userSource } = useUtmTracking();
  const {
    brand: { currency, clientName },
  } = useI18nContext();

  const locale = getLang();
  const sessionId = sessionStorage.getItem("sessionId");
  const currencyCode = currency.code;
  const headers = {};

  if (sessionId) headers["Riskified-Session-Id"] = sessionId;

  return (
    <AxiosInterceptors
      trackingProperties={featureFlags as unknown as TrackingPropertiesType}
      userSource={userSource}
      userMedium={userMedium}
      userCampaign={userCampaign}
      tenant={clientName}
      locale={locale}
      currency={currencyCode}
      version={version}
      requestHeaders={headers}
      logResponse={createResponseLog}
      logRequest={createRequestLog}
      logError={createResponseErrorLog}
    >
      {children}
    </AxiosInterceptors>
  );
};

export default AxiosInterceptorWrapper;
